import { TablePaginationConfig } from 'antd/lib'

import { DEFAULT_PER_PAGE } from 'src/app-constants'

export const resetPagination = (pagination: TablePaginationConfig) => {
  pagination.onChange?.(1, DEFAULT_PER_PAGE)
}
